import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Fallback-Komponente für React.lazy() geladene Komponenten
 * Zeigt einen zentrierten Spinner mit optionaler Nachricht
 */
const LazyLoadFallback = ({ message = 'Lädt...' }) => (
    <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
    >
        <CircularProgress size={40} />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            {message}
        </Typography>
    </Box>
);

export default LazyLoadFallback;
